import { useSelector } from 'react-redux';

const useMessagingSidebar = () => {
  const showSidebarMessageItem = useSelector(state => state.authentication)
    ?.retailer_info?.response?.text_messaging_available;

  return showSidebarMessageItem;
};

export default useMessagingSidebar;
